<span class="hk-compliment">
  <img class="hk-compliment__icon" alt=""
       src="assets/design-tokens/images/compliments/{{complimentIcon}}.svg">
  <span class="hk-compliment__label">
    {{ complimentDisplay }}
  </span>
</span>
